// extracted by mini-css-extract-plugin
module.exports = {"container":"Approved_container__OBot4","subContainer":"Approved_subContainer__2CVmH","flex":"Approved_flex__2U8LE","classTxtarea":"Approved_classTxtarea__i7fd7"};